import { CalendarEvent } from './dashboard.types';
import { Event } from '../calendar/calendar.event.types';
import { DashboardState } from './dashboard.types';

export const transformCalendarEvents = (dashboardState: DashboardState): Array<Event> => {
  if (dashboardState && dashboardState.dashboardCalendarEvents) {
    return dashboardState.dashboardCalendarEvents.map((calendarEvent: CalendarEvent, index: number) => {
      return {
        title: calendarEvent.title,
        allDay: false,
        start: new Date(calendarEvent.startDate),
        end: new Date(calendarEvent.endDate),
        desc: calendarEvent.note,
        id: calendarEvent.id,
        backgroundColor: calendarEvent.colorValue
      };
    });
  } else {
    return [];
  }
};


// WEBPACK FOOTER //
// ./src/dashboard/dashboard.util.tsx